import { validateAddress } from "../validateAddress"

const BTC_TESTNET_BECH32_RE = /^tb1/i

export function normalizeQrBitcoinAddress(input: string): string {
  const trimmed = input.trim()
  return /^bc1/i.test(trimmed) ? trimmed.toLowerCase() : trimmed
}

export function isSupportedQrBitcoinAddress(input: string): boolean {
  const trimmed = input.trim()
  if (BTC_TESTNET_BECH32_RE.test(trimmed)) return false
  return validateAddress(normalizeQrBitcoinAddress(trimmed), "bitcoin")
}
